import { useState } from 'react'
import * as Yup from 'yup'
import TextInput from '../organisms/TextInput'
import ValidatedForm from '../organisms/ValidatedForm'
import { ValidatedPrimaryButton } from '../organisms/ValidationButton'
// import {appSnackbarActions} from '../../store/features/appSnackbar'
// import { userSliceActions } from '../../store/features/user'
import { toast } from 'react-toastify'
import signIn from '../../api/auth/signIn'
import { ISchemaAdminInfo } from '../../shared/types'
import { translateAuthErrors } from '../../utils/errorTranslator'

const initialValues= {
    email: "",
    password: "",
}


const validationSchema = Yup.object().shape({
    email: Yup.string().required().email().label("contact"),
    password: Yup.string().required().min(5).max(30).label("password")
})

export default function SignIn() {

    const [isLoading, setIsLoading] = useState(false)

    const submit = async (data:ISchemaAdminInfo, resetForm:()=>void)=>{

        try {

            setIsLoading(true)
            await signIn(data.email, data.password)
            
        } catch (error) {
            setIsLoading(false)
            toast(translateAuthErrors(error),{
                position: "top-center",
                autoClose: 5000,
                className:"text-center",
                type: "warning"
            })
            resetForm()

        }

       

    }

    return (
        <div
            className="pattern_bg h-88%"
        >
            
            <div
                className="absolute top-1/2 left-1/2 translate-x-neg-1/2 translate-y-neg-1/2"
            >
                <form
                    className='bg-white p-8 rounded shadow-2xl'
                >
                    <ValidatedForm
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={(values, formikHelpers)=>submit(values, formikHelpers.resetForm)}
                    >
                        <div className='sm:w-72'>
                            <header className='text-center leading-4'>
                                <h1 className="text-primary font-bold" >Hi There<span role="img" aria-label='smiling emoji' >👋</span> </h1>
                                <span className="text-graphite" >Please complete the form below to access your <br /> shop.</span>
                            </header>
                        </div>

                        <div
                            className="my-12"
                        >

                            <TextInput
                                name="email"
                                text="Email"
                                placeholder="email"
                                type="email"
                            />
                            
                            <div className="mt-4">
                                <TextInput
                                    name="password"
                                    text="Password"
                                    placeholder="password"
                                    type="password"
                                />
                            </div>

                            {/* <div className="my-6">
                                
                            </div> */}
                            
                        </div>
                        <ValidatedPrimaryButton
                            loading={isLoading}
                            disabled={isLoading}
                        >
                            Signin
                        </ValidatedPrimaryButton>
                    </ValidatedForm>
                </form>


            </div>

        </div>
    )
}
